import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../Data Service/data.service';

@Injectable({
  providedIn: 'root'
})
export class CsvDownloadService {
  constructor(private http: HttpClient, private data: DataService) {}

  downloadCsv(data: any[], fileName: string = 'download.csv', headingMap: { [key: string]: string }, columns?: string[]) {
    const headers = columns || Object.keys(data[0] || {});
    const csvContent = this.convertToCSV(data, headers, headingMap);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  private convertToCSV(data: any[], headers: string[], headingMap: { [key: string]: string }): string {
    const getValueFromPath = (obj: any, path: string): any => {
      try {
        return path
          .replace(/\[(\w+)\]/g, '.$1')
          .split('.')
          .reduce((acc, key) => (acc && key in acc ? acc[key] : ''), obj);
      } catch {
        return '';
      }
    };

    const headerRow = headers.map(h => headingMap[h] || h).join(',');
    const csvRows = data.map(row =>
      headers
        .map(header => {
          let cellValue = getValueFromPath(row, header);
          if (Array.isArray(cellValue)) cellValue = cellValue.join(', ');
          cellValue = cellValue ?? '';
          cellValue = String(cellValue).replace(/"/g, '""');
          if (cellValue.includes(',') || cellValue.includes('"') || cellValue.includes('\n')) {
            cellValue = `"${cellValue}"`;
          }
          return cellValue;
        })
        .join(',')
    );

    return [headerRow, ...csvRows].join('\n');
  }

  getCsvBlob(data: any[], headingMap: { [key: string]: string }, columns?: string[]): Blob {
    const headers = columns || Object.keys(data[0] || {});
    const csvContent = this.convertToCSV(data, headers, headingMap);
    return new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  
  }

  sendEmailWithCsvAttachment(
    emailRequest: any,
    csvData: any[],
    headingMap: { [key: string]: string },
    columns?: string[]
  ) {
    const csvBlob = this.getCsvBlob(csvData, headingMap, columns);

    const formData = new FormData();
    formData.append('file', csvBlob, 'report.csv');
    formData.append(
      'emailRequest',
      new Blob([JSON.stringify(emailRequest)], { type: 'application/json' })
    );

    
    this.data.EmailCsv(formData).subscribe(
      (response) => {
        console.log('', response);
      
  })

  }
}
